import React from 'react';
import useLocales from 'hooks/useLocales';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface IVersionNotifierProps {
  isOpen: boolean;
  onRefresh?: () => void;
  onClose?: () => void;
}

export const VersionNotifier: React.FC<IVersionNotifierProps> = ({ isOpen }) => {
  const { translate } = useLocales();
  const theme = useTheme();

  return (
    <Dialog
      open={isOpen}
      disableEscapeKeyDown
      fullWidth={true}
      onClose={(event, reason) => {
        // Prevent closing via backdrop click
        if (reason === 'backdropClick') return;
      }}
      PaperProps={{
        sx: {
          borderRadius: '4px !important',
        },
      }}
    >
      <DialogTitle
        sx={{
          paddingBottom: '0 !important',
          paddingTop: '4px !important',
          fontWeight: 700,
          fontSize: '16px',
        }}
      >
        {translate('update_available')}
        <span style={{ fontSize: 20, marginLeft: 8 }}>🚀</span>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: '0 24px 4px 24px !important',
        }}
      >
        {translate('new_app_verion_available')}
      </DialogContent>

      <DialogActions
        sx={{
          '.MuiDialog-paper &': {
            padding: '0 24px 8px 24px !important',
          },
        }}
      >
        <Button
          variant="contained"
          size="medium"
          sx={{
            textTransform: 'capitalize',
          }}
          onClick={() => window.location.reload()}
        >
          {translate('refresh')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
